import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/admin/utilizatori")({
  beforeLoad: () => {
    throw redirect({ to: "/admin/setari", search: { tab: "utilizatori" } });
  },
  component: () => null,
});
